import { Flex, Button, Spacer, Box } from '@chakra-ui/react';
import { Header } from '../Common/Brand';

const TermsAndConditions = () => {
  return (
    <Flex
      direction="column"
      color="#401605"
      gap={5}
      width="100%"
      maxWidth="7xl"
    >
      <Header size="h1" marginTop={'80px'}>
        Terms and Conditions
      </Header>
      Last updated: January 15, 2022 Please read these terms and conditions
      carefully before using Our Service.
      <Header size="h2">Interpretation and Definitions</Header>
      <Header size="h3">Interpretation</Header>
      The words of which the initial letter is capitalized have meanings defined
      under the following conditions. The following definitions shall have the
      same meaning regardless of whether they appear in singular or in plural.
      <Header size="h3">Definitions</Header>
      For the purposes of these Terms and Conditions:
      <br />
      Affiliate means an entity that controls, is controlled by or is under
      common control with a party, where &quot;control&quot; means ownership of
      50% or more of the shares, equity interest or other securities entitled to
      vote for election of directors or other managing authority.
      <br />
      Country refers to: New Jersey, United States
      <br />
      Company (referred to as either &quot;the Company&quot;, &quot;We&quot;,
      &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Ekatree.
      <br />
      Device means any device that can access the Service such as a computer, a
      cellphone or a digital tablet.
      <br />
      Service refers to the Website.
      <br />
      Terms and Conditions (also referred as &quot;Terms&quot;) mean these Terms
      and Conditions that form the entire agreement between You and the Company
      regarding the use of the Service. This Terms and Conditions agreement has
      been created with the help of the Terms and Conditions Generator.
      <br />
      Third-party Social Media Service means any services or content (including
      data, information, products or services) provided by a third-party that
      may be displayed, included or made available by the Service.
      <br />
      Website refers to Ekatree, accessible from https://www.ekatree.com
      <br />
      You means the individual accessing or using the Service, or the company,
      or other legal entity on behalf of which such individual is accessing or
      using the Service, as applicable.
      <br />
      <Header size="h3">Referrals</Header>
      We’re excited to offer a referral program where you can earn rewards for
      getting your friends, family, or anyone to join our app! Here’s how it
      works: you’ll receive rewards once your referrals sign up using your
      unique code and place their first order through the app. Your referrals
      need to be real users, not duplicate or fake accounts, and live in the
      building listed as their residence on Ekatree. We will verify your
      referred users before distributing rewards. We’ll notify you once you’ve
      reached any reward milestone and it is up to you pickup the reward from
      certain locations on reward distribution days. Rewards will not be shipped
      or delivered. Keep in mind that the program is for a limited time only to
      change so be sure to take advantage of it while it’s active.
      <h5>1. **Promotion Overview**</h5>
      By participating in the referral program, users have the opportunity to
      earn rewards by referring new users to the platform. Rewards will be
      granted once specific referral benchmarks are met.
      <h5>2. **Eligibility**</h5>
      To participate in this promotion, you must be a registered user of the app
      and comply with all the terms and conditions set forth herein.
      <h5>3. **Referral Benchmarks and Rewards**</h5>
      Each referral must be a valid and successful new user registration through
      your unique referral link. Rewards will be awarded when you meet the
      specified referral benchmarks. The nature and quantity of the rewards will
      be determined by the company and may vary based on the tier of
      achievement.
      <h5>4. **Winner Notification**</h5>
      Winners who qualify for rewards will be notified via in-app messaging or
      the contact information provided upon registration. The company reserves
      the right to determine the method of notification and any further
      instructions for claiming rewards.
      <h5>5. **Promotion Termination**</h5>
      The company reserves the right to modify, suspend, or terminate the
      referral program at any time without prior notice. If the promotion is
      ended, no further referrals will be counted toward rewards after the
      termination date.
      <h5>6. **Fraudulent Activity**</h5>
      Any attempt to manipulate or exploit the referral program, including but
      not limited to creating multiple accounts, referring fictitious users, or
      providing false information, may result in disqualification from the
      promotion and forfeiture of any earned rewards. Users must also be
      legitimate residents of the building they have registered in the app, and
      any violation of this requirement will be considered fraudulent activity.
      <h5>7. **Release of Liability**</h5>
      By participating in the referral program, users agree that they cannot
      hold the company, its affiliates, or any of its representatives liable for
      any damages, losses, or legal claims arising from participation in the
      program or from any rewards earned or not earned. Users explicitly waive
      the right to file a lawsuit or initiate any legal proceedings against the
      company in relation to their involvement in the referral program, the
      prizes awarded, or any changes to the promotion.
      <h5>8. **General Conditions**</h5>
      The company reserves the right to interpret, modify, or enforce these
      terms and conditions at its discretion. Participation in the referral
      program constitutes acceptance of these terms, including the release of
      liability clause.
      <br />
      <br />
      <br />
      For further details or inquiries regarding this promotion, please contact
      our support team.
      <Header size="h3">Acknowledgment</Header>
      These are the Terms and Conditions governing the use of this Service and
      the agreement that operates between You and the Company. These Terms and
      Conditions set out the rights and obligations of all users regarding the
      use of the Service.
      <br />
      Your access to and use of the Service is conditioned on Your acceptance of
      and compliance with these Terms and Conditions. These Terms and Conditions
      apply to all visitors, users and others who access or use the Service.
      <br />
      By accessing or using the Service You agree to be bound by these Terms and
      Conditions. If You disagree with any part of these Terms and Conditions
      then You may not access the Service.
      <br />
      You represent that you are over the age of 18. The Company does not permit
      those under 18 to use the Service.
      <br />
      Your access to and use of the Service is also conditioned on Your
      acceptance of and compliance with the Privacy Policy of the Company. Our
      Privacy Policy describes Our policies and procedures on the collection,
      use and disclosure of Your personal information when You use the
      Application or the Website and tells You about Your privacy rights and how
      the law protects You. Please read Our Privacy Policy carefully before
      using Our Service.
      <Header size="h3">Links to Other Websites</Header>
      Our Service may contain links to third-party web sites or services that
      are not owned or controlled by the Company.
      <br />
      The Company has no control over, and assumes no responsibility for, the
      content, privacy policies, or practices of any third party web sites or
      services. You further acknowledge and agree that the Company shall not be
      responsible or liable, directly or indirectly, for any damage or loss
      caused or alleged to be caused by or in connection with the use of or
      reliance on any such content, goods or services available on or through
      any such web sites or services.
      <br />
      We strongly advise You to read the terms and conditions and privacy
      policies of any third-party web sites or services that You visit.
      <Header size="h3">Termination</Header>
      We may terminate or suspend Your access immediately, without prior notice
      or liability, for any reason whatsoever, including without limitation if
      You breach these Terms and Conditions.
      <br />
      Upon termination, Your right to use the Service will cease immediately.
      <Header size="h3">Limitation of Liability</Header>
      For all messages sent, carriers are not liable for delayed or undelivered
      messages.
      <br />
      Notwithstanding any damages that You might incur, the entire liability of
      the Company and any of its suppliers under any provision of this Terms and
      Your exclusive remedy for all of the foregoing shall be limited to the
      amount actually paid by You through the Service or 100 USD if You
      haven&apos;t purchased anything through the Service.
      <br />
      To the maximum extent permitted by applicable law, in no event shall the
      Company or its suppliers be liable for any special, incidental, indirect,
      or consequential damages whatsoever (including, but not limited to,
      damages for loss of profits, loss of data or other information, for
      business interruption, for personal injury, loss of privacy arising out of
      or in any way related to the use of or inability to use the Service,
      third-party software and/or third-party hardware used with the Service, or
      otherwise in connection with any provision of this Terms), even if the
      Company or any supplier has been advised of the possibility of such
      damages and even if the remedy fails of its essential purpose.
      <br />
      Some states do not allow the exclusion of implied warranties or limitation
      of liability for incidental or consequential damages, which means that
      some of the above limitations may not apply. In these states, each
      party&apos;s liability will be limited to the greatest extent permitted by
      law.
      <br />
      &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; Disclaimer
      <br />
      The Service is provided to You &quot;AS IS&quot; and &quot;AS
      AVAILABLE&quot; and with all faults and defects without warranty of any
      kind. To the maximum extent permitted under applicable law, the Company,
      on its own behalf and on behalf of its Affiliates and its and their
      respective licensors and service providers, expressly disclaims all
      warranties, whether express, implied, statutory or otherwise, with respect
      to the Service, including all implied warranties of merchantability,
      fitness for a particular purpose, title and non-infringement, and
      warranties that may arise out of course of dealing, course of performance,
      usage or trade practice. Without limitation to the foregoing, the Company
      provides no warranty or undertaking, and makes no representation of any
      kind that the Service will meet Your requirements, achieve any intended
      results, be compatible or work with any other software, applications,
      systems or services, operate without interruption, meet any performance or
      reliability standards or be error free or that any errors or defects can
      or will be corrected.
      <br />
      Without limiting the foregoing, neither the Company nor any of the
      company&apos;s provider makes any representation or warranty of any kind,
      express or implied: (i) as to the operation or availability of the
      Service, or the information, content, and materials or products included
      thereon; (ii) that the Service will be uninterrupted or error-free; (iii)
      as to the accuracy, reliability, or currency of any information or content
      provided through the Service; or (iv) that the Service, its servers, the
      content, or e-mails sent from or on behalf of the Company are free of
      viruses, scripts, trojan horses, worms, malware, timebombs or other
      harmful components.
      <br />
      Some jurisdictions do not allow the exclusion of certain types of
      warranties or limitations on applicable statutory rights of a consumer, so
      some or all of the above exclusions and limitations may not apply to You.
      But in such a case the exclusions and limitations set forth in this
      section shall be applied to the greatest extent enforceable under
      applicable law.
      <Header size="h3">Governing Law</Header>
      The laws of the Country, excluding its conflicts of law rules, shall
      govern this Terms and Your use of the Service. Your use of the Application
      may also be subject to other local, state, national, or international
      laws.
      <Header size="h3">Disputes Resolution</Header>
      If You have any concern or dispute about the Service, You agree to first
      try to resolve the dispute informally by contacting the Company.
      <br />
      For European Union (EU) Users
      <br />
      If You are a European Union consumer, you will benefit from any mandatory
      provisions of the law of the country in which you are resident in.
      <br />
      United States Legal Compliance
      <br />
      You represent and warrant that (i) You are not located in a country that
      is subject to the United States government embargo, or that has been
      designated by the United States government as a &quot;terrorist
      supporting&quot; country, and (ii) You are not listed on any United States
      government list of prohibited or restricted parties.
      <Header size="h3">SMS Notifications and Messages</Header>
      By providing your phone number during account creating and pressing the
      “Next” button below, you agree to receive automated text messages from
      Ekatree, a brand of Orderio Inc. and also agree to our Terms of Service
      and Privacy Policy. Consent is not a condition of purchase. Message
      frequency will vary. Message and data rates may apply. Reply HELP for help
      or STOP to cancel.Carriers are not liable for delayed or undelivered
      messages.
      <Header size="h2">Severability and Waiver</Header>
      <Header size="h3">Severability</Header>
      If any provision of these Terms is held to be unenforceable or invalid,
      such provision will be changed and interpreted to accomplish the
      objectives of such provision to the greatest extent possible under
      applicable law and the remaining provisions will continue in full force
      and effect.
      <Header size="h3">Waiver</Header>
      Except as provided herein, the failure to exercise a right or to require
      performance of an obligation under these Terms shall not effect a
      party&apos;s ability to exercise such right or require such performance at
      any time thereafter nor shall the waiver of a breach constitute a waiver
      of any subsequent breach.
      <Header size="h3">Translation Interpretation</Header>
      These Terms and Conditions may have been translated if We have made them
      available to You on our Service. You agree that the original English text
      shall prevail in the case of a dispute.
      <Header size="h3">Changes to These Terms and Conditions</Header>
      We reserve the right, at Our sole discretion, to modify or replace these
      Terms at any time. If a revision is material We will make reasonable
      efforts to provide at least 30 days&apos; notice prior to any new terms
      taking effect. What constitutes a material change will be determined at
      Our sole discretion.
      <br />
      By continuing to access or use Our Service after those revisions become
      effective, You agree to be bound by the revised terms. If You do not agree
      to the new terms, in whole or in part, please stop using the website and
      the Service.
      <Header size="h3">Contact Us</Header>
      If you have any questions about these Terms and Conditions, You can
      contact us:
      <br />
      By email: customerservice@ekatree.com
      <br />
      Generated using TermsFeed Privacy Policy Generator
    </Flex>
  );
};

export default TermsAndConditions;
